import React from 'react';
import { HelpBox } from '../help-boxes';
import { Dialog } from 'primereact/dialog';
import styled from 'styled-components';
import { SecondaryButton } from '../buttons';

type Props = {
  isOpened: boolean;
  comment: string;
  onClose: () => void;
  headerTitle: string;
  preserveLineBreaks?: boolean;
};

const StatusCommentFullViewDialog: React.FC<Props> = ({
  headerTitle,
  isOpened,
  comment,
  onClose,
  preserveLineBreaks,
}) => {
  return (
    <Dialog
      header={headerTitle}
      visible={isOpened}
      style={{ maxWidth: 560 }}
      onHide={onClose}
      footer={null}
      closable={false}
    >
      <HelpBox
        style={{
          maxWidth: 500,
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
          marginLeft: 30,
          marginRight: 30,
          whiteSpace: preserveLineBreaks ? 'pre-line' : undefined,
        }}
      >
        {comment}
      </HelpBox>
      <ButtonContainer>
        <SecondaryButton label="Close" onClick={onClose} />
      </ButtonContainer>
    </Dialog>
  );
};

export const ButtonContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
`;

export default StatusCommentFullViewDialog;
